export default __webpack_public_path__ + "media/images/yukiho_not_found-eba25a406d8fa9b032629fb9ef74afb7.png";